<template>
  <div class="manage-header white-bg flex">
    <div class="manage-header-left flex align-items">
      <router-link to="/" class="logo" title="回到首页"><img :src="pcLogo"></router-link>
      <div class="login-type" v-if="this.$store.state.user_type === 0">企业管理中心</div>
      <div class="login-type" v-if="this.$store.state.user_type === 1">达人管理中心</div>
    </div>
    <div class="manage-header-right flex align-items" v-if="this.$store.state.user_type === 0">
      <el-tooltip class="item" effect="dark" content="查看新消息" placement="bottom" v-if="is_new == 1">
        <router-link to="/enterprise/message" class="new-message relative">
            <i class="dot absolute"></i>
            <i class="el-icon-bell"></i>
        </router-link>
      </el-tooltip>
      <router-link to="/enterprise/message" class="new-message relative" v-if="is_new == 0">
        <i class="el-icon-bell"></i>
      </router-link>
      <div class="user-info flex align-items" @mouseenter="userOperateShow" @mouseleave="userOperateHide">
        <span class="logo" v-if="enterprise_logo"><img :src="enterprise_logo"></span>
        <span class="logo" v-if="!enterprise_logo"><img src="@/assets/images/default-head.jpg"></span>
        <i class="el-icon-arrow-down"></i>
        <transition name="el-fade-in">
        <ul class="user-operate absolute" v-show="isOperate">
          <li>{{ep_name}}</li>
          <li @click="loginOut">退出登录</li>
        </ul>
        </transition>
      </div>
    </div>
    <div class="manage-header-right flex align-items" v-if="this.$store.state.user_type === 1">
      <el-tooltip class="item" effect="dark" content="查看新消息" placement="bottom" v-if="is_new == 1">
        <router-link to="/daren/message" class="new-message relative">
          <i class="dot absolute"></i>
          <i class="el-icon-bell"></i>
        </router-link>
      </el-tooltip>
      <router-link to="/daren/message" class="new-message relative" v-if="is_new == 0">
        <i class="el-icon-bell"></i>
      </router-link>
      <div class="user-info flex align-items" @mouseenter="userOperateShow" @mouseleave="userOperateHide">
        <span class="logo" v-if="head_img"><img :src="head_img"></span>
        <span class="logo" v-if="!head_img"><img src="@/assets/images/default-head.jpg"></span>
        <i class="el-icon-arrow-down"></i>
        <transition name="el-fade-in">
        <ul class="user-operate absolute" v-show="isOperate">
          <li>{{daren_name}}</li>
          <li @click="loginOut">退出登录</li>
        </ul>
        </transition>
      </div>
    </div>
  </div>
</template>
<script>
  import {
    newsData,
    gethomepc
  } from '@/config/api.js'
  export default {
    name: 'ManageHeader',
    data () {
      return {
        is_new: null,
        isOperate: false,
        pcLogo: ''
      }
    },
    props: {
      ep_name: String,
      enterprise_logo: String,
      daren_name: String,
      head_img: String,
    },
    methods: {
      getMessage () {
        if (this.$store.state.user_type === 0) {
          let data = {
            user_type:0,
            user_id:this.$store.state.user_id,
          };
          this.$post(newsData,data)
                  .then(res => {
                    let data = res.data;
                    this.is_new = data.is_new;
                  })
                  .catch(err => {
                    window.console.log(err)
                  })
        } else if (this.$store.state.user_type === 1) {
          let data = {
            user_type:1,
            user_id:this.$store.state.user_id,
          };
          this.$post(newsData,data)
                  .then(res => {
                    let data = res.data;
                    this.is_new = data.is_new;
                  })
                  .catch(err => {
                    window.console.log(err)
                  })
        }
      },
      userOperateShow () {
        this.isOperate = true
      },
      userOperateHide () {
        this.isOperate = false
      },
      loginOut () {
        this.$confirm('确定要退出吗？是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$store.commit('changeCode' ,'');
          this.$store.commit('changeAuthToken' ,'');
          this.$store.commit('changeOpenId' ,'');
          this.$store.commit('changeUnionId' ,'');
          this.$store.commit('changeIsAuth' ,NaN);
          this.$store.commit('changeId' ,NaN);
          this.$store.commit('changeUserType' ,3);
          this.$store.commit('changeIsOperater' ,0);
          this.$store.commit('changeIsPass' ,NaN);
          this.$store.commit('changeAuthType' ,NaN);
          this.$store.commit('changeRank' ,NaN);
          this.$store.commit('changeNewbieTask' ,NaN);
          this.$store.commit('changeIsAgent' ,NaN);
          this.$store.commit('changeIsAnswer' ,NaN);
          this.$store.commit('changeIsInfo' ,NaN);
          this.$store.commit('changeWeChatNumber' ,NaN);
          this.$store.commit('changeWeChatFriendNum' ,NaN);
          this.$store.commit('changeSource' ,NaN);
          this.$store.commit('changeLabel' ,NaN);
          this.$store.commit('changeGetTime' ,NaN);
          this.$store.commit('changeIsOfficial' ,NaN);
          this.$message({
            type: 'success',
            message: '成功退出!'
          });
          setTimeout(() => {
            this.$router.push('/')
          },1000)
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消退出'
          });
        });
      },
      getLogo () {
        let data = {
          key: 'pc_home_page'
        };
        this.$post(gethomepc,data)
                .then( res => {
                  let data = JSON.parse(res.data);
                  this.pcLogo = data.logo
                })
      }
    },
    created() {
      this.getMessage();
      this.getLogo();
    },
    // watch: {
    //   "$route": "getMessage"
    // }
  }
</script>
<style scoped>
  .manage-header{width:100%;height:70px;border-bottom:1px #EBEBEB solid;position:fixed;top:0;left: 0;z-index: 99;}
  .manage-header .manage-header-left{width:calc(100% - 156px);}
  .manage-header .manage-header-left .logo{margin-left:20px;}
  .manage-header .manage-header-left .logo img{width:153px;height: 32px;}
  .manage-header .manage-header-left .login-type{margin-left:10px;background: #242944;color:#fff;padding:0 10px;height:24px;line-height: 24px;border-radius: 5px;}
  .manage-header .manage-header-right{height: 70px;line-height: 70px;}
  .manage-header .manage-header-right .new-message{display: block;padding:0 20px;font-size: 20px;}
  .manage-header .manage-header-right .new-message:hover{background: #F9F9F9;}
  .manage-header .manage-header-right .new-message .dot{width: 6px;height: 6px;border-radius: 100%;background: #ff0000;top:22px;left:38px;}
  .manage-header .manage-header-right .user-info{padding:0 20px;display: block;height: 70px;cursor:pointer;}
  .manage-header .manage-header-right .user-info span img{margin-top: 21px;width: 28px;height: 28px;border-radius: 100%;margin-right:10px;}
  .manage-header .manage-header-right .user-info:hover{background: #F9F9F9;}
  .manage-header .manage-header-right .user-operate{right:0;top:70px;background: #fff;box-shadow: 0 0 6px rgba(0,0,0,.1);border-radius: 5px;width:240px;}
  .manage-header .manage-header-right .user-operate li{padding:0 20px;height: 40px;line-height: 40px;}
  .manage-header .manage-header-right .user-operate li:first-child{border-bottom: 1px #F5F5F5 solid;}
  /*.manage-header .logo img{height:35px;}*/
  .manage-header .info{margin:10px 30px 0 0;line-height:30px;}
  .manage-header .info .user img{width:30px;height:30px;border-radius: 50%;}
  .manage-header .info .name{margin:0 10px 0 5px;}
  .manageLink{line-height:50px;margin-left:20px;}
</style>
